import { getCrackInjectionResults, getDowelingResults } from '../common/calculationUtils'

export const dowelingCalculationUpload = (input, staticData) => {
  let response = {}

  if (
    input.validation &&
    (input.validation['numberInstallations'] || input.validation['embedmentDepth'])
  ) {
    response = {
      msgLevel: 'error',
      msgHeader: 'Input Validation Error',
      msgBody: input.validation['numberInstallations'] || input.validation['embedmentDepth'],
    }
    return response
  } else {
    const results = getDowelingResults(input, staticData)
    response = Object.assign({}, { results: results })
    return response
  }
}
export const crackInjectionCalculationUpload = (input, staticData) => {
  let response = null

  if (input.validation && (input.validation['crackDepth'] || input.validation['crackLength'])) {
    response = {
      msgLevel: 'error',
      msgHeader: 'Input Validation Error',
      msgBody: input.validation['crackDepth'] || input.validation['crackLength'],
    }
    return response
  } else {
    const results = getCrackInjectionResults(input, staticData)
    response = Object.assign({}, results)
    return response
  }
}

export const dowelingCalculation = (input, staticData) => {
  let response = {}

  return (dispatch) => {
    dispatch({ type: 'CALCULATION_INIT' })

    if (input.validation['numberInstallations'] || input.validation['embedmentDepth']) {
      response = {
        msgLevel: 'error',
        msgHeader: 'Input Validation Error',
        msgBody: input.validation['numberInstallations'] || input.validation['embedmentDepth'],
      }
      dispatch(calculationError(response))
    } else {
      const results = getDowelingResults(input, staticData)
      response = Object.assign({}, { results: results })
      dispatch(calculationSuccess(response))
    }

  }
}

export const crackInjectionCalculation = (input, staticData) => {
  let response = null

  return (dispatch) => {
    dispatch({ type: 'CALCULATION_INIT' })

    if (input.validation['crackDepth'] || input.validation['crackLength']) {
      response = {
        msgLevel: 'error',
        msgHeader: 'Input Validation Error',
        msgBody: input.validation['crackDepth'] || input.validation['crackLength'],
      }
      dispatch(calculationError(response))
    } else {
      const results = getCrackInjectionResults(input, staticData)
      response = Object.assign({}, results)
      dispatch(calculationSuccess(response))
    }

  }
}

export const calculationSuccess = (data) => {
  return {
    type: 'CALCULATION_SUCCESS',
    payload: data,
  }
}
export const calculationError = (error) => {
  return {
    type: 'CALCULATION_FAILURE',
    payload: { status: error },
  }
}

export const onChangeCB = (name, value, dispatch) => {
  dispatch({ type: 'FIELD_UPDATE_CALCULATION', payload: { [name]: value } })
}
